import ShapeInterface from '../../Interfaces/ShapeInterface';
import { useFormikContext, ErrorMessage } from 'formik';
import { sectionSettings, selectedConfiguratorModel } from '../../Helpers/WindowHelpers';
import Dimension from './Dimension';

interface DimensionsInterface {
    shapes: ShapeInterface[];
}

const Dimensions = ({ shapes }: DimensionsInterface) => {
    const context = useFormikContext<any>();
    const selectedShape = shapes.find((shape) => shape.shape_id == context.values?.shape);
    if (!selectedShape) return null;
    const dimensionsLocked = !!selectedConfiguratorModel?._model;

    return (
        <div className="configurator-content__table">
            {selectedShape.dimensions.map((dimension, index) => <Dimension
                key={index}
                dimension={dimension}
                selectedShape={selectedShape}
                individualDimension={false}
                disabled={dimensionsLocked}
                title={(<>
                    <DimensionTitle dimension={dimension.dimension.toUpperCase()} selectedShape={selectedShape} />
                    {dimension.dimension == 'a' && selectedShape.dimension_a_enforce_longest == 'true' && <LongestSection />

                    }</>)}
            />)}
            <ErrorMessage name="dimensionsValid" component={"div"} className={"configurator-content__error rte links-blue"} />
        </div>
    );
}

const DimensionTitle = ({ dimension, selectedShape }: { dimension: string, selectedShape: ShapeInterface }) =>
    selectedShape.shape_id == 'Custom_Shape'
        ? <span>{sectionSettings.label_custom_shape_dimension}</span>
        : <span>{sectionSettings.label_dimension} {dimension}:</span>

const LongestSection = () =>
    <small className="text--italic text--xs">{sectionSettings.label_dimension_longest}</small>

export default Dimensions;
